import React from 'react';
import crossImg from './gig-cross.svg';

const gigSummary = (gigIdx, title, description, url, clickFn) =>
  <div
    className="gigSummary"
    key={`${parseInt(gigIdx, 10)}_${title}`}
    onClick={clickFn.bind(this, gigIdx)}
  >
    <div className="gigSummaryTitle">
      <span className="gigTitle">{title}</span>
      <span className="gigX"><img src={crossImg} alt=""/></span>
    </div>
    <div className="gigSummaryDescription">
      {description}
    </div>
  </div>

class Gigs extends React.Component {

  handleClick(gigIdx) {
    window.location = `/gigdetail/${gigIdx}`;
  }


  render() {
    const headingL1Style = {
      width: "2.5em",
      fontSize: "79px",
      marginTop: "0.7em",
      marginBottom: "0",
      lineHeight: "0.9em",
    };
    const headingL2Style = {
      width: "5em",
      fontSize: "51px",
      marginTop: "7px",
      marginBottom: "10px",
    };
    const h2Style = {
      display: "inline-block",
      color: "#B3B3B3",
      backgroundColor: "#252525",
      fontSize: "35px",
      marginTop: "0.5em",
      marginBottom: "0",
    };

    return (
      <React.Fragment>
        <p style={headingL1Style} className="gigsHeading">GIGS</p>
        <p style={headingL2Style} className="gigsHeading">UNLOCKED:</p>
        <p style={h2Style}>YOU ARE NOW ABLE </p>
        <p style={h2Style}>TO ACCESS THESE</p><br/>
        <p style={h2Style}>JOBS...</p>
        <div className="gigs" >
          {
            this.props.gigs.map((gig, idx) => {
              return gigSummary(
                idx,
                gig.gigTitle,
                gig.gigDesc,
                gig.gigURL,
                this.handleClick
              )
            })
          }
        </div>
      </React.Fragment>
    );
  }
}

export default Gigs;



// WEBPACK FOOTER //
// ./src/components/Gigs/index.js